import { importPhotoCounts } from "../../utils/sourceCoverage";

/** @param {{importState: any}} props */
export default function PhotoImportCoverage({ importState }) {
  const counts = importPhotoCounts(importState);
  if (!counts || counts.found === null || counts.selected !== 10 || counts.found <= 10) return null;
  return (
    <p aria-label="Photo import coverage">
      This import is limited to 10 photos. {counts.selected} of {counts.found} photos found on
      Zillow were selected; {counts.found - counts.selected} were outside the import limit.
    </p>
  );
}
